import { useContext, useEffect } from 'react';

import { Button, Typography } from '@/ui';
import { track } from '@/utils';

import OnboardingImage from '@/components/GetStarted/OnboardingImage.png';
import { GetStartedContext } from '@/components/GetStarted/context';

const OnboardingVideo = () => {
  const { nextStep } = useContext(GetStartedContext);

  useEffect(() => {
    track('ob_video');
  }, []);

  const onNext = () => {
    track('ob_video_cont');
    nextStep();
  };

  return (
    <main className="bg-gradient-dark-sunny flex flex-1 flex-col overflow-auto">
      <div className="flex flex-col pb-20 md:pb-0">
        <div className="container mx-auto p-4 text-center md:mt-4">
          <Typography className="mb-5" variant="h4">
            Your Mento Onboarding in 3 Steps
          </Typography>
          <div className="mx-auto mb-8 max-w-screen-md">
            <img
              alt="Your Mento Onboarding in 3 Steps"
              className="mx-auto w-full max-w-[600px]"
              src={OnboardingImage}
            />
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 mt-auto w-full px-6 pb-4 text-center text-sm md:static md:mb-6 md:mt-0 md:py-6">
        <Button
          className="w-full min-w-72 md:w-72"
          color="primary"
          variant="contained"
          onClick={onNext}
        >
          Let's get started
        </Button>
      </div>
    </main>
  );
};

export default OnboardingVideo;
